import { appStore } from '../store/app-store';
import { orderStore } from '../store/order-store';
import { apiService } from './api-service';

export const orderService = {
  async submit() {
    const state = appStore.get();
    const requestId = state.pendingOrderRequestId ?? crypto.randomUUID();
    if (!state.pendingOrderRequestId) appStore.set({ pendingOrderRequestId: requestId }, false);
    let order;
    try {
      order = await apiService.submitOrder({ items: orderStore.lines().map((line) => ({ ...line })), total: orderStore.total(), comment: state.comment, promoCode: state.promoCode, requestId });
    } catch (error) {
      if ((error as { code?: string })?.code === 'IIKO_ORDER_CREATION_FAILED') appStore.set({ pendingOrderRequestId: null }, false);
      throw error;
    }
    // The checkout screen needs the complete submitted-order state before it
    // changes route.  Its caller performs the final cart cleanup below.
    appStore.set({
      orders: [order, ...state.orders],
      selectedOrderId: order.id,
      orderNumber: order.id,
      statusStep: 0,
      pendingOrderRequestId: null,
    }, false);
    return order.id;
  },
};
